export const urlParser = (url: string | undefined, anchor?: string) => {
  const anchorLink = anchor ? `#${anchor}` : ""
  if (!url) return "#"
  if (url.startsWith("http")) return url
  if (url.startsWith("tel:")) return url
  const href = url.startsWith("/") ? url : `/${url}`

  return `${process.env.HOME_URL}${href}` + anchorLink
}
